module.exports = __webpack_public_path__ + "img/appAsset-brand--stripe.30b4602c.svg";